import { useMemo, useState } from 'react';

import { FilterComboBoxMenuItem } from '../../filter-combo-box/filter-combo-box-menu-item';
import { Popover } from '../../popover/popover';
import { BatchAction } from '../batch-action';

export interface GroupActionProps {
  options: string[];
  value?: string;
  onChange: (value?: string) => void;
}

export const GroupAction = (props: GroupActionProps) => {
  const { onChange, options, value } = props;

  const [isOpen, setIsOpen] = useState(false);

  const renderOptions = useMemo(
    () =>
      [...options, 'No groups'].map((option) => {
        const item = { label: option, value: option };
        return (
          <FilterComboBoxMenuItem
            key={option}
            item={item}
            defaultSelection={option === 'No groups' ? value === undefined : value === option}
            className=" pr-5 text-sm"
            onSelect={({ value }) => {
              setIsOpen(false);
              onChange(value === 'No groups' ? undefined : value);
            }}
          />
        );
      }),
    [options, value, onChange]
  );
  return (
    <Popover
      content={renderOptions}
      showArrow={false}
      innerContentClassName="flex-col max-h-60 overflow-y-auto rounded-md border-t border-t-gray-300 shadow-dark"
      trigger="external"
      open={isOpen}
      onOpenChange={setIsOpen}
      placement={'bottom-end'}
    >
      <BatchAction
        type="group"
        onClick={() => {
          setIsOpen(true);
        }}
      />
    </Popover>
  );
};
